import './styles.scss';

import { each } from 'lodash';

const CheckboxGroup = () => import('../../components/checkbox-group/index.vue');

export default {
    name: 'MessagingFloorsPage',

    components: {
        'checkbox-group': CheckboxGroup
    },

    data() {
        return {
            list: []
        }
    },

    computed: {
        subscription() {
            return this.$store.state.subscriptions.active_subscription;
        },

        stored_floors() {
            return this.$store.state.messaging.floors;
        },
        
        building() {
            return this.$store.getters.getActiveBuilding;
        },
        
        floors() {
            const floors = this.$store.getters.getActiveBuilding.floors;
            const all_floors = [];
            each(floors, (floor) => {
                const obj = {
                    title: floor.name,
                    id: floor.id,
                    isChecked: false
                }
                all_floors.push(obj);
            });
            return all_floors;
        }

    },

    watch: {
        floors(newValue, oldValue) {
            if (!this.stored_floors.length) {
                this.list = this.floors;
            }
        }
    },

    created() {
        this.$store.commit('setMenuDetails', { 
            title: 'Emergency Messages', 
            slug: 'messaging',
            back_url: '/action/emergency-messages/group-types'
        });

        if (this.stored_floors.length) {
            this.list = this.stored_floors;
        }

        this.$store.dispatch('fetchBuildingProfile');
    },

    methods: {
        updateValues(list) {
            this.list = list;
            this.$store.commit('setMessageFloors', list);
        },

        next() {
            this.$store.commit('setMessageFloors', this.list);
            this.$router.push('/action/emergency-messages/notification-types');
        },

        cancel() {
            this.$ionic.alertController.create({
                header: 'Are you sure you want to cancel?',
                message: 'This action cannot be undone.',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            this.$store.commit('resetMessage');
                            this.$router.push('/action');
                        },
                    },
                    {
                        text: 'No',
                        role: 'cancel'
                    }
                ],
            }).then(a => a.present());
        }
    }
};